module.exports = __webpack_public_path__ + "img/thumbnail_Platypus_j_normal.679d5e7b.png";